import { CreativeTagEvent } from '../enums';
import { Creative } from '../types';

export class AssetLoadEventNotifier {
  constructor(
    private readonly creative: Creative,
    private readonly htmlTag: HTMLElement,
    private readonly container: HTMLElement
  ) {}

  public async waitForReady(): Promise<void> {
    const isAssetLoaded = new Promise<void>(resolve => {
      this.creative.addEventListener(CreativeTagEvent.CreativeAssetLoad, () => {
        resolve();
      });
    });

    const isHtmlTagInDOM = new Promise<void>(resolve => {
      this.observeHtmlTagInsertion(this.container, this.htmlTag, () => {
        resolve();
      });
    });

    await Promise.all([isAssetLoaded, isHtmlTagInDOM]);
  }

  private observeHtmlTagInsertion(
    container: HTMLElement,
    htmlTag: HTMLElement,
    onInserted?: () => void
  ) {
    const observer = new MutationObserver((mutations, obs) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node === htmlTag) {
            if (onInserted) onInserted();
            obs.disconnect();
          }
        });
      });
    });
    observer.observe(container, { childList: true });
  }
}
